const _temp0 = require("url:./avatars/akshat.jpg");
const _temp1 = require("url:./avatars/aman.jpg");
const _temp2 = require("url:./avatars/andrew.jpg");
const _temp3 = require("url:./avatars/ankur.jpg");
const _temp4 = require("url:./avatars/brandon.jpg");
const _temp5 = require("url:./avatars/cam.jpg");
const _temp6 = require("url:./avatars/christine.jpg");
const _temp7 = require("url:./avatars/connor.jpg");
const _temp8 = require("url:./avatars/daleee.jpg");
const _temp9 = require("url:./avatars/dann.jpg");
const _temp10 = require("url:./avatars/danny.jpg");
const _temp11 = require("url:./avatars/david.jpg");
const _temp12 = require("url:./avatars/divish.jpg");
const _temp13 = require("url:./avatars/elizabeth.jpg");
const _temp14 = require("url:./avatars/evert.jpg");
const _temp15 = require("url:./avatars/gabriel.jpg");
const _temp16 = require("url:./avatars/jack.jpg");
const _temp17 = require("url:./avatars/jack_z.jpg");
const _temp18 = require("url:./avatars/jen.jpg");
const _temp19 = require("url:./avatars/jingru.jpg");
const _temp20 = require("url:./avatars/kaoru.jpg");
const _temp21 = require("url:./avatars/kareem.jpg");
const _temp22 = require("url:./avatars/ken.jpg");
const _temp23 = require("url:./avatars/kieran.jpg");
const _temp24 = require("url:./avatars/lamisa.jpg");
const _temp25 = require("url:./avatars/liz.jpg");
const _temp26 = require("url:./avatars/lune.jpg");
const _temp27 = require("url:./avatars/marco.jpg");
const _temp28 = require("url:./avatars/matt.jpg");
const _temp29 = require("url:./avatars/mattMihok.jpg");
const _temp30 = require("url:./avatars/metkel.jpg");
const _temp31 = require("url:./avatars/michael.jpg");
const _temp32 = require("url:./avatars/mike.jpg");
const _temp33 = require("url:./avatars/nicole.jpg");
const _temp34 = require("url:./avatars/niya.jpg");
const _temp35 = require("url:./avatars/rachael.jpg");
const _temp36 = require("url:./avatars/rajat.jpg");
const _temp37 = require("url:./avatars/sami.jpg");
const _temp38 = require("url:./avatars/sherry.jpg");
const _temp39 = require("url:./avatars/simon.jpg");
const _temp40 = require("url:./avatars/taz.jpg");
const _temp41 = require("url:./avatars/tehseen.jpg");
const _temp42 = require("url:./avatars/yuri.jpg");
module.exports = {
  "akshat": _temp0,
  "aman": _temp1,
  "andrew": _temp2,
  "ankur": _temp3,
  "brandon": _temp4,
  "cam": _temp5,
  "christine": _temp6,
  "connor": _temp7,
  "daleee": _temp8,
  "dann": _temp9,
  "danny": _temp10,
  "david": _temp11,
  "divish": _temp12,
  "elizabeth": _temp13,
  "evert": _temp14,
  "gabriel": _temp15,
  "jack": _temp16,
  "jack_z": _temp17,
  "jen": _temp18,
  "jingru": _temp19,
  "kaoru": _temp20,
  "kareem": _temp21,
  "ken": _temp22,
  "kieran": _temp23,
  "lamisa": _temp24,
  "liz": _temp25,
  "lune": _temp26,
  "marco": _temp27,
  "matt": _temp28,
  "mattMihok": _temp29,
  "metkel": _temp30,
  "michael": _temp31,
  "mike": _temp32,
  "nicole": _temp33,
  "niya": _temp34,
  "rachael": _temp35,
  "rajat": _temp36,
  "sami": _temp37,
  "sherry": _temp38,
  "simon": _temp39,
  "taz": _temp40,
  "tehseen": _temp41,
  "yuri": _temp42
}